import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { getDataSession } from 'views/Utils/Common';
import { avisarError, Campo, cargar, dinero, sucursalActual, Tarjeta, tokenOperacion } from '../comun';

const CobroCxC = ({ history, match }) => {
    const { changeGlobalTitle } = useUIUtils();
    const [clientes, setClientes] = useState([]);
    const [cajas, setCajas] = useState([]);
    const [cajeros, setCajeros] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [formas, setFormas] = useState([]);
    const [saldos, setSaldos] = useState([]);
    const [clienteId, setClienteId] = useState('');
    const [cajaId, setCajaId] = useState('');
    const [cajeroId, setCajeroId] = useState('');
    const [vendedorId, setVendedorId] = useState('');
    const [descripcion, setDescripcion] = useState('Abono de factura');
    const [cobros, setCobros] = useState([{ forma_Cobro_Id: '', importe: 0 }]);
    const lista = match.url.replace(/\/cobrocxc$/, '');

    useEffect(() => {
        changeGlobalTitle('Cobro de cuentas por cobrar', 'Abono a saldos pendientes.');
        cargar(`clientes/GetList?sucursal_id=${sucursalActual()}&empresa_id=${getDataSession('empresa')}&paginas=0&totalXpagina=100&busqueda=`).then(setClientes);
        cargar(`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}&almacen_id=0&paginas=0&totalXpagina=200&busqueda=`).then(setCajas);
        cargar(`pv/PvCajeros/GetList?usuario_id=0&sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=200`).then(setCajeros);
        cargar(`vendedores/GetList?sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=100&busqueda=`).then(setVendedores);
        cargar('pv/PvFormasCobros/GetList?paginas=0&totalXpagina=200&busqueda=').then(setFormas);
    }, [changeGlobalTitle]);

    function consultarSaldos(idCliente) {
        setClienteId(idCliente);
        if (!idCliente) {
            setSaldos([]);
            return;
        }
        cargar(`pv/PvDocumentos/SaldosPendientes?sucursal_Id=${sucursalActual()}&cliente_id=${idCliente}`).then((listaSaldos) => {
            setSaldos(listaSaldos.map((item) => ({ ...item, abono: 0 })));
        });
    }

    function cobrar(event) {
        event.preventDefault();
        fetchConToken('pv/PvDocumentos/CobroCxC', {
            sucursal_Id: Number(sucursalActual()),
            caja_Id: Number(cajaId),
            cajero_Id: Number(cajeroId),
            cliente_Id: Number(clienteId),
            vendedor_Id: Number(vendedorId || 0),
            descripcion,
            idempotency_Token: tokenOperacion('cxc'),
            aplicaciones: saldos.filter((item) => Number(item.abono) > 0).map((item) => ({
                documento_CC_Id: item.documento_CC_Id,
                importe: Number(item.abono)
            })),
            cobros: cobros.filter((item) => item.forma_Cobro_Id).map((item) => ({
                tipo: 'C',
                forma_Cobro_Id: Number(item.forma_Cobro_Id),
                importe: Number(item.importe),
                tipo_Cambio: 1,
                moneda: 'MXN'
            }))
        }, 'POST').then((response) => {
            if (avisarError(response)) return;
            Swal.fire('Exito', `Cobro ${response.folio || ''} registrado`, 'success');
            history.push(`${lista}/ver/${response.id}`);
        }).catch(alertService.error);
    }

    return (
        <div className='container-fluid'>
            <form onSubmit={cobrar}>
                <div className='mb-3'><Link to={lista} className='btn btn-outline-warning'>Regresar</Link></div>
                <Tarjeta titulo='Cobro de cuentas por cobrar'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <Campo label='Cliente'>
                                <select className='form-select' required value={clienteId} onChange={({ target }) => consultarSaldos(target.value)}>
                                    <option value=''>Seleccione</option>
                                    {clientes.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                </select>
                            </Campo>
                        </div>
                        <div className='col-md-4'>
                            <Campo label='Caja'>
                                <select className='form-select' required value={cajaId} onChange={({ target }) => setCajaId(target.value)}>
                                    <option value=''>Seleccione</option>
                                    {cajas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                </select>
                            </Campo>
                        </div>
                        <div className='col-md-4'>
                            <Campo label='Cajero'>
                                <select className='form-select' required value={cajeroId} onChange={({ target }) => setCajeroId(target.value)}>
                                    <option value=''>Seleccione</option>
                                    {cajeros.map((item) => <option key={item.id} value={item.id}>Cajero {item.id}</option>)}
                                </select>
                            </Campo>
                        </div>
                        <div className='col-md-4'>
                            <Campo label='Vendedor'>
                                <select className='form-select' value={vendedorId} onChange={({ target }) => setVendedorId(target.value)}>
                                    <option value=''>Sin vendedor</option>
                                    {vendedores.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                </select>
                            </Campo>
                        </div>
                        <div className='col-md-8'><Campo label='Descripcion'><input className='form-control' value={descripcion} onChange={({ target }) => setDescripcion(target.value)} /></Campo></div>
                    </div>
                    <table className='table table-sm'>
                        <thead><tr><th>Folio</th><th>Concepto</th><th>Saldo</th><th>Abono</th></tr></thead>
                        <tbody>
                            {saldos.map((item, index) => (
                                <tr key={item.documento_CC_Id}>
                                    <td>{item.folio}</td>
                                    <td>{item.concepto}</td>
                                    <td>{dinero(item.saldo_Pendiente)}</td>
                                    <td>
                                        <input type='number' className='form-control' value={item.abono} onChange={({ target }) => {
                                            const copia = [...saldos];
                                            copia[index] = { ...copia[index], abono: target.value };
                                            setSaldos(copia);
                                        }} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {cobros.map((item, index) => (
                        <div className='row' key={index}>
                            <div className='col-md-6'>
                                <Campo label='Forma de cobro'>
                                    <select className='form-select' value={item.forma_Cobro_Id} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], forma_Cobro_Id: target.value };
                                        setCobros(copia);
                                    }}>
                                        <option value=''>Seleccione</option>
                                        {formas.map((forma) => <option key={forma.id} value={forma.id}>{forma.nombre}</option>)}
                                    </select>
                                </Campo>
                            </div>
                            <div className='col-md-3'>
                                <Campo label='Importe'>
                                    <input type='number' className='form-control' value={item.importe} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], importe: target.value };
                                        setCobros(copia);
                                    }} />
                                </Campo>
                            </div>
                        </div>
                    ))}
                    <button type='submit' className='btn btn-outline-success'>Registrar cobro</button>
                </Tarjeta>
            </form>
        </div>
    );
};

export { CobroCxC };
